import { ref, watch } from "vue";

let instance = null;

export const useEmployeeFilters = () => {
  if (instance) return instance;

  const defaultParams = ref({
    limit: 10,
    offset: 0,
    ordering: "first_name",
  });

  const dynamicFilters = ref({});

  const finalQueryParams = ref({
    ...defaultParams.value,
    ...dynamicFilters.value,
  });

  watch(
    [defaultParams, dynamicFilters],
    () => {
      finalQueryParams.value = {
        ...defaultParams.value,
        ...dynamicFilters.value,
      };
    },
    { deep: true, immediate: true }
  );

  const setPaginationLimit = (limit) => {
    defaultParams.value.limit = limit;
  };

  const setPaginationOffset = (offset) => {
    defaultParams.value.offset = offset;
  };

  const setOrderingField = (fieldName) => {
    defaultParams.value.ordering = fieldName;
  };

  const addFilter = (key, value) => {
    if (value !== null && value !== undefined && value !== "") {
      const newFilters = { ...dynamicFilters.value };
      if (Object.prototype.hasOwnProperty.call(newFilters, key)) {
        const existingValue = newFilters[key];
        if (Array.isArray(existingValue)) {
          if (!existingValue.includes(value)) {
            newFilters[key] = [...existingValue, value];
          }
        } else if (existingValue !== value) {
          newFilters[key] = [existingValue, value];
        }
      } else {
        newFilters[key] = value;
      }
      dynamicFilters.value = newFilters;
    } else {
      const newFilters = { ...dynamicFilters.value };
      delete newFilters[key];
      dynamicFilters.value = newFilters;
    }
  };

  const removeFilter = (key, value = null) => {
    if (!Object.prototype.hasOwnProperty.call(dynamicFilters.value, key)) {
      return;
    }

    const newFilters = { ...dynamicFilters.value };

    if (value === null) {
      delete newFilters[key];
    } else {
      const existingValue = newFilters[key];
      if (Array.isArray(existingValue)) {
        const newValues = existingValue.filter((item) => item !== value);
        if (newValues.length === 0) {
          delete newFilters[key];
        } else if (newValues.length === 1) {
          newFilters[key] = newValues[0];
        } else {
          newFilters[key] = newValues;
        }
      } else if (existingValue === value) {
        delete newFilters[key];
      }
    }
    dynamicFilters.value = newFilters;
  };

  const clearDynamicFilters = () => {
    dynamicFilters.value = {};
  };

  const resetInstance = () => {
    instance = null;
  };

  instance = {
    defaultParams,
    dynamicFilters,
    finalQueryParams,
    setPaginationLimit,
    setPaginationOffset,
    setOrderingField,
    addFilter,
    removeFilter,
    clearDynamicFilters,
    resetInstance,
  };
  return instance;
};

// Export a function to reset the singleton from outside
export const resetEmployeeFilters = () => {
  instance = null;
};
